
<template>
    <div>
        <div>
            <div class="col-lg-12" v-if="isLoadingBlade && ! showAddPage">
                <div class="d-flex justify-content-center">
                    <img :src="loadingBladeUrl" />
                </div>
            </div>

            <div class="container" v-if="! isLoadingBlade">
                <div class="row">
                    <div class="col-lg-12 text-right">
                        <button
                            class="btn btn-lg btn-primary"
                            @click="displayAddPage(true)"
                            v-if="! showAddPage && ! showAddOfflinePage"
                            :disabled="(privileges && privileges.add == 'no') || ! privileges"
                        >
                            <i class="fa fa-plus"></i>
                            Add Online Doctors To List
                        </button>
                        &nbsp;&nbsp;
                        <button
                            class="btn btn-lg btn-info"
                            @click="displayAddOfflinePage(true)"
                            v-if="! showAddPage && ! showAddOfflinePage"
                            :disabled="(privileges && privileges.add == 'no') || ! privileges"
                        >
                            <i class="fa fa-plus"></i>
                            Add Offline Doctors To List
                        </button>

                        <button
                            class="btn btn-lg btn-danger"
                            @click="displayAddPage(false)"
                            v-if="showbackButton"
                        >
                            <i class="fa fa-reply"></i>
                            Go back
                        </button>
                        <br><br>
                    </div>
                </div>

                <div class="row" v-if="! showAddPage && ! showAddOfflinePage && ! showErrorStatus">
                    <div class="col-lg-2">
                        <base-input alternative="" v-show="! searchKey">
                            <select
                                class="form-control form-control-alternative"
                                v-model="page"
                                @change="getPageItems()"
                            >
                                <option
                                    v-for="number in pageNumbers"
                                    :key="number"
                                    :value="number"
                                >
                                    {{ number }}
                                </option>
                            </select>
                        </base-input>
                    </div>
                    <div class="col-lg-4"></div>
                    <div class="col-lg-6 text-right">
                        <base-input
                            placeholder="Search by Name/Folio Number and hit enter"
                            class="input-group-alternative"
                            alternative=""
                            addon-right-icon="fas fa-search"
                            @change="searchRecords"
                            v-model="searchKey"
                            >
                        </base-input>
                    </div>
                </div>
            </div>

            <!-- import Sanctions Data template here -->
            <SanctionsData
                :records="records"
                :hasPagination="hasPagination"
                :pagination="pagination"
                :paginate="paginate"
                :privileges="privileges"
                :searchKey="searchKey"
                :loadSanctions="loadSanctions"
                v-on:removeSanction="removeSanction"
                v-on:editSanction="editSanction"
                :getFullName="getFullName"
                v-if="! showAddPage && ! showAddOfflinePage && ! isLoadingBlade"
            />

            <div
                class="col-sm-12 text-center"
                v-if="showErrorStatus && ! showAddPage && ! showAddOfflinePage && ! isLoadingBlade"
            >
                <base-alert :type="errorType">
                    <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span>
                    <span class="alert-inner--text">
                        {{errorMsg}}
                    </span>
                </base-alert>
            </div>
        </div>

        <!-- import Add Sanction template here -->
        <AddSanction
            :privileges="privileges"
            v-if="showAddPage && ! showAddOfflinePage && ! isLoadingBlade"
        />

        <!-- import Add Offline Sanction template here -->
        <AddOfflineSanction
            :privileges="privileges"
            :data="record"
            :locations="locations"
            :displayAddOfflinePage="displayAddOfflinePage"
            v-if="! showAddPage && showAddOfflinePage && ! isLoadingBlade"
        />

    </div>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex';
  import SanctionsData from './SanctionsData';
  import AddSanction from './AddSanction';
  import AddOfflineSanction from './AddOfflineSanction';
  import swal from 'sweetalert2';// import sweet alert

  export default {
    name: 'Sanctions',
    props: ['privileges', 'changeTitle'],
    components: {
        SanctionsData,
        AddSanction,
        AddOfflineSanction
    },
    data() {
      return {
        showErrorStatus: false,
        errorType: null,
        errorMsg: null,
        isLoadingBlade: true,
        records: [],
        paginatedItems: [],
        pagination: {
            total: null,
            prev_page_url: null,
            next_page_url: null,
            current_page: null,
            last_page: null,
            number: 1,
            from: 0,
            to: null,
            perPage: this.$store.state.url.perPage // get per page count
        },
        page: 1,
        searchKey: null,
        showAddPage: false,
        showAddOfflinePage: false,
        showbackButton: false,
        record: null
      }
    },
    computed: {
        ...mapGetters(['menus', 'loadingBladeUrl', 'locations']),
        hasPagination() {
            return this.pagination.next_page_url || this.pagination.prev_page_url;
        },
        pageNumbers() {
            let start = 1;
            let end = this.pagination.last_page;
            let pages = [];
            for (let i = start; i <= end; i++ ) {
                pages.push(i);
            }
            return pages;
        }
    },
    methods: {
        ...mapActions(['getSanctions', 'getPaginatedPaymentItems', 'getSearchedSanctions', 'removeUserSanction', 'getLocations']),
        displayAddPage(value) {
            let title = 'Add Online Doctors to Sanction List';
            this.changeTitle(title, value);
            this.showbackButton = value;
            this.loadSanctions();
            this.showAddOfflinePage = false;
            return this.showAddPage = value;
        },
        displayAddOfflinePage(value) {
            let title = 'Add Offline Doctors to Sanction List';
            this.changeTitle(title, value);
            this.showbackButton = value;
            this.loadSanctions();
            this.showAddPage = false;
            this.record = null;
            return this.showAddOfflinePage = value;
        },
        editSanction(data) {
            this.record = data;
            let title = 'Edit <em class="text-danger">'+ this.getFullName(data) + '\'s</em> Sanction Details';
            this.changeTitle(title, true);
            this.showbackButton = true;
            this.showAddPage = false;
            return this.showAddOfflinePage = true;
        },
        getFullName(data) {// get full name
            let user = data && data.user_data ? data.user_data : false;
            if(user) {
                let name = user.first_name+' ';
                name += user.other_name ? user.other_name+' ' : '';
                name += user.last_name+'';
                return name.toLowerCase();
            } else {
                return 'N/A';
            }
        },
        loadSanctions() {// load details
            let data = { 'limit' : this.pagination.perPage };
            this.isLoadingBlade = true;
            this.showErrorStatus = false;
            this.getSanctions(data).then((res) => {// get users
                this.isLoadingBlade = false;
                this.setPages(res.sanctions);//set data
            }).
            catch(() => {
                this.records = [];
                this.showErrorStatus = true;
                this.isLoadingBlade = false;
                this.errorMsg = "Server Failure!, Kindly reload the page...";
                this.errorType = 'danger';
            });
        },
        setPages(res) {// set paginated function
            this.records = [];
            this.paginatedItems = res.data;
            this.records = this.paginatedItems;
            this.pagination.from = res.from;
            this.pagination.to = res.to;
            this.pagination.total = res.total;
            this.pagination.current_page = res.current_page;
            this.pagination.last_page = res.last_page;
            this.pagination.prev_page_url = res.prev_page_url;
            this.pagination.next_page_url = res.next_page_url;
            this.isLoadingBlade = false;
            this.emptyRecordsMsg();//show empty msg
        },
        paginate() {// paginate function
            this.showErrorStatus = false;
            let url = (this.pagination.number > this.pagination.current_page) ?
                this.pagination.next_page_url : this.pagination.prev_page_url;
            if(url) {// make api call
                this.isLoadingBlade = true
                this.getPaginatedPaymentItems(url).then((res) => {// get users
                    this.pagination.number = res.sanctions.current_page;
                    this.setPages(res.sanctions);
                }).
                catch(() => {
                    this.users = [];
                    this.showErrorStatus = true;
                    this.isLoadingBlade = false;
                    this.errorMsg = "Server Failure!, Kindly reload the page...";
                    this.errorType = 'danger';
                });
            } else {
                this.records = this.paginatedItems;
            }
        },
        emptyRecordsMsg() {
            return this.records && this.records.length == 0 ? this.showEmptyMsg() : false;
        },
        showEmptyMsg() {// show empty msg
            this.showErrorStatus = true;
            this.errorType = 'warning';
            this.errorMsg = 'No Sanctions recorded yet!!!';
        },
        getPageItems() {
            let url = this.pagination.next_page_url ?
                        this.pagination.next_page_url : this.pagination.prev_page_url;
            let exploded = url.split('&');
            let newUrl = exploded[0]+'&'+exploded[1]+'&'+exploded[2]+'&page='+this.page;
            this.isLoadingBlade = true
            this.getPaginatedPaymentItems(newUrl).then((res) => {// get records
                this.pagination.number = res.sanctions.current_page;
                this.setPages(res.sanctions);
            }).
            catch(() => {
                this.records = [];
                this.showErrorStatus = true;
                this.isLoadingBlade = false;
                this.errorMsg = "Server Failure!, Kindly reload the page...";
                this.errorType = 'danger';
            });
        },
        searchRecords() {
            this.showErrorStatus = false;
            let key = this.searchKey.toLowerCase();
            if(key) {
                this.isLoadingBlade = true;
                let data = { 'key' : key };
                this.records = [];
                this.getSearchedSanctions(data).then((res) => {// get records
                    this.isLoadingBlade = false;
                    this.records = res;
                    if(this.records.length == 0) {
                        this.showErrorStatus = true;
                        this.errorType = 'warning';
                        this.errorMsg = 'No Matched Record!!!';
                    }
                }).
                catch(() => {
                    this.showErrorStatus = true;
                    this.isLoadingBlade = false;
                    this.errorMsg = "Server Failure!, Kindly reload the page...";
                    this.errorType = 'danger';
                });
            } else {
                this.records = this.paginatedItems;
                this.emptyRecordsMsg();
            }
        },
        removeSanction(id) {
            swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, Proceed!'
            }).then((result) => {
                if (result.value) {
                    this.makeRemoveApiCall(id);// make api call
                }
            });
        },
        makeRemoveApiCall(id) {
            let data = { 'id' : id, 'admin_id' : this.$store.state.user.userId };
            this.preloader(); // show loading
            this.removeUserSanction(data).then((res) => {// delete country
                if(res.status) {
                    this.loadSanctions();// refresh page
                    swal.fire("Sanction Lifted", res.msg, "success");
                } else {
                    this.loadSanctions();// refresh page
                    swal.fire("Error Occurred!", res.msg, "warning");
                }
            }).
            catch(err => {
                this.loadSanctions();// refresh page
                swal.fire(err.message+"!", "An error occurred while deleting, try again", "warning");
            });
        },
        preloader() {
            return  swal.fire({
                title: 'Please Wait...',
                html: 'Trying to fetch data from <b>server</b>',
                // timer: 2000,
                timerProgressBar: true,
                onBeforeOpen: () => {
                    swal.showLoading()
                },
            });
        }
    },
    mounted() {
        this.loadSanctions();
        this.getLocations();
    }
  };
</script>
<style>
    .table td {
        font-size: 15px;
    }
</style>
